import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

function Heading({ children, className, ...props }) {
  return (
    <h2 className={classnames('heading-2', className)} {...props}>
      {children}
    </h2>
  );
}

Heading.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired
};

Heading.defaultProps = {
  className: ''
};

function Subheading({ children, className, ...props }) {
  return (
    <p className={classnames('secondary', className)} {...props}>
      {children}
    </p>
  );
}

Subheading.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired
};

Subheading.defaultProps = {
  className: ''
};

export default function Section({ className, children, ...props }) {
  return (
    <section
      className={classnames('font-16 pv12 pv20-md', className)}
      {...props}
    >
      <div className="container-xxl">{children}</div>
    </section>
  );
}

Section.Heading = Heading;
Section.Subheading = Subheading;

Section.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired
};

Section.defaultProps = {
  className: ''
};
